import { render, staticRenderFns } from "./Trainings.vue?vue&type=template&id=2a1c6b7d&scoped=true"
import script from "./Trainings.vue?vue&type=script&lang=js"
export * from "./Trainings.vue?vue&type=script&lang=js"
import style0 from "./Trainings.vue?vue&type=style&index=0&id=2a1c6b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c6b7d",
  null
  
)

export default component.exports